<template>
  <li class="goods-bd">
    <div class="wrap" @click="onlink">
      <div class="img-box">
        <img v-if="imgurl" :src="imgurl" alt="">
        <img v-else src="http://i1.mifile.cn/a1/T1cqAgB7hv1RXrhCrK!180x180.jpg" alt="">
      </div>
      <div class="info">
        <h1 class="line1">{{title}}</h1>
        <p>￥{{price}}/{{unit}}</p>
      </div>
    </div>
  </li>
</template>
<script>
export default {
  name: 'tGoods',
  props: {
    imgurl: { type: String, default: '' },
    title: { type: String, default: '' },
    price: { type: String, default: '' },
    unit: { type: String, default: '' },
  },
  methods: {
    onlink: function () {
      this.$emit('link');
    },
  },
};

</script>
<style scoped lang="scss">
.goods-bd {
  width: 50%;
  margin-bottom: 4px;
  &:nth-child(odd) {
    padding-right: 2px;
  }
  &:nth-child(even) {
    padding-left: 2px;
  }
  .wrap {
    display: block;
    height: 100%;
    background-color: #ffffff;
    .img-box {
      overflow: hidden;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .info {
      padding: 0.08rem .1rem .1rem .1rem;
      h1 {
        height: .12rem;
        line-height: .13rem;
        font-size: .12rem;
        color: #202020;
      }
      p {
        margin-top: 0.08rem;
        font-size: .15rem;
        color: #f80052;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/custom/goods.vue